import React from "react";
import "./style.css";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";
import {MEAL_COUNT} from "../../../../const/WeightLossQuestionnaire";

export const MealCount = (props) => {
  const data = {
    title: "How many meals do you prefer to have in a day?",
    list: [{
      content: "No preference",
    },...MEAL_COUNT]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireSelect list={data} {...props} />
    </div>
  );
};
